import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'

import { darkTheme, lightTheme } from './theme'

export function createAppVuetify(isSSR = false) {
  return createVuetify({
    ssr: isSSR,
    theme: {
      defaultTheme: 'darkTheme',
      themes: {
        darkTheme,
        lightTheme
      }
    },
    defaults: {
      VCard: {
        VBtn: {
          variant: 'outlined'
        }
      },
      VTextField: {
        variant: 'solo'
      },
      VSelect: {
        variant: 'solo'
      }
    }
  })
}
